<template>
  <el-dialog
      title="开发票"
      :visible.sync="visible"
      modal-append-to-body
      width="500px"
      :before-close="handleClose">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
        v-loading="loading"
    >
      <el-form-item label-width="0px" prop="businessLicenseId">
<!--        <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>-->
        <el-upload
            class="upload-demo"
            :before-upload="(e) => handleBeforeUpload(e)"
            action="/"
            :on-remove="handleRemove"
            drag
            :file-list="fileList"
            accept=".pdf"
        >
<!--            <img class="image-card" v-if="invoiceImg" :src="invoiceImg" alt/>-->
<!--            <img-->
<!--                class="icon-check"-->
<!--                v-if="invoiceImg"-->
<!--                @click.stop="checkImage()"-->
<!--                src="@/assets/login/icon-check-img.png"-->
<!--                alt-->
<!--            />-->
<!--            <img-->
<!--                v-if="!ruleForm.invoiceImg"-->
<!--                src="@/assets/invoice.png"-->
<!--                alt-->
<!--            />-->
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <span class="fz14 fc9">上传发票</span>

        </el-upload>
      </el-form-item>
    </el-form>

    <el-image-viewer :zIndex="99999" v-if="isShowPics" :on-close="closeViewer" :url-list="srcList" />

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="loading" @click="handleSubmit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import axios from 'axios'
import {auth} from "@/utils/auth";
export default {
  components: {  ElImageViewer },
  name: "invoiceUpload",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    tradeNo: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      loading: false,
      rules: {},
      ruleForm: {
        pdfFile: ''
      },
      fileList: [],
      imageUrl: '',
      isShowPics: false,
      srcList: [],
      invoiceImg: '',
      uploadFileUrl: process.env.VUE_APP_API_BASE_URL + "/kq/index/handleInvoice", // 上传文件服务器地址
    }
  },
  methods:{
    handleRemove(file, fileList) {
      if (file && file.status == 'success'){
        this.fileList = fileList
      }
    },
    handleSubmit(){
      this.loading = true
      let token = auth.getKqToken();
      let pdfFile = new FormData()
      pdfFile.append('pdfFile',this.fileList[0])
      pdfFile.append('tradeNo',this.tradeNo)
      axios({
        method: "POST",
        url: this.uploadFileUrl,
        data: pdfFile,
        headers: {
          'Authorization': token,
        }
      }).then(resp=>{
        if(resp.data.code===200){
          this.$message.success(resp.data.msg);
          this.updateDialog(false)
          this.$emit('refresh')
          this.loading = false;
        }else if (resp.data.code===500){
          this.$message.error(resp.data.msg)
          this.loading = false
        }
      }).catch(error => {
        this.$message.error(resp.data.msg)
        this.loading = false
      })
    },
    handleBeforeUpload(file) {
        this.fileList = [file]
      // const reader = new FileReader();
      // reader.readAsDataURL(file); // 转换为Base64
      // reader.onload = (e) => {
      //   this.invoiceImg = e.target.result;
      //   console.log(e.target.result)
      //   let position = e.target.result.indexOf("base64");
      //   let lastIndex = position * 1 + 7;
      //   this.ruleForm.invoiceImg = e.target.result.slice(lastIndex);
      //   // this.request(base, type);
      // };
      return false; // 阻止默认上传行为
    },
    closeViewer() {
      this.isShowPics = false;
    },
    checkImage() {
      this.srcList = [];
      this.srcList.push(this.ruleForm.invoiceImg);
      this.isShowPics = true;
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
.avatar-uploader {
  position: relative;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
::v-deep .el-upload {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

::v-deep .el-upload-dragger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-upload-list__item-name{
  display: flex;
}

::v-deep .el-dialog__body{
  padding: 30px 20px 0 20px;
}

::v-deep .el-form-item{
  margin-bottom: 0;
}
</style>
